<template>
  <v-card class="dialog">
    <v-container class="ma-0 pa-0">
      <v-form ref="form" v-model="valid">
        <v-card-title class="primary px-4">
          <span v-if="page <= 1" class="headline">EMITIR ALTERAÇÕES</span>
        </v-card-title>
        <v-card-text class="px-4">
          <v-layout column row v-if="page === 1">
            <v-layout wrap>
              <v-layout>
                <v-flex class="textModal" style=" " pb-3
                  >Tem certeza que deseja emitir as alterações?</v-flex
                >
              </v-layout>
             
            </v-layout>
          </v-layout>
        </v-card-text>
        <v-card-actions class="px-4 pb-5">
          <v-layout row wrap>
            <v-flex class="special-flex" v-if="page === 1" offset-md4 md4 xs6>
              <v-btn  @click="fechar" class="btn-width-maior" flat color="primary">
                CANCELAR
              </v-btn>
            </v-flex>
            <v-flex class="special-flex" v-if="page === 1" md4 xs6>
              <v-btn
                class="button-permanecer btn-width-maior" 
                @click="enviar"
                flat
              >
                CONFIRMAR
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-form>
    </v-container>
    <v-snackbar v-model="snack" auto-height="true" :timeout="3500" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import { number } from "bfj-node4/src/events";
import usuarioHelper from "@/helpers/usuario-logado";


export default {
  name: "ModalEmitirEndossoAlteracao",

  data() {
    return {
      menu: false,
      snack: false,
      valid: false,
      snackColor: "",
      snackText: "",
      erroAjuda: null,
      dialogProgress: false,
      dialogError: false,
      errorMessage: "",
      errorDetails: null,
      page: 1,
      regras: {
        notNull: [
          v =>
            (v !== null && v !== undefined && v !== "") ||
            "Você não pode deixar este campo em branco"
        ]
      }
    };
  },

  props: {
    dialog: Boolean,
    idApolice: Number,
    idPropostaStatus: String,
  },
  computed: {
    elementoPai: function() {
      return this.$parent;
    }
  },

  methods: {
    fechar() {
      this.$emit("fechar");
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    enviar() {
      this.$emit("comecarLoading");
      const objetoEnvio = this.$store.getters["formEndosso/conteudoSalvarEndosso"]
      axios
      .post(
            `${process.env.URL_ENDOSSOMS}/v1/emitirEndosso/${this.idApolice}`,
               objetoEnvio,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
        .then(() => {
          this.$emit("fecharLoading");
          this.save();
          setTimeout(() => {
            this.$router.push("/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice + "&idPropostaStatus=" + this.idPropostaStatus);
            
          }, 2000);
        })
        .catch(error => {
          this.$emit("fecharLoading");
          this.snack = true;
          this.snackColor = "error";
          if (error.response && error.response.data) {
           
            this.snackText =  error.response.data.erros || error.response.data.message;
          
          } else {
            this.snackText = error.response.data.message;
          }

        });
    },

  }
};
</script>

<style scoped>
.color {
  background-color: #eaeaea;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.textModal {
  color: black;
  font-size: 16px;
  color: #646464; 
  text-align: left;
}

.textModal2 {
  color: black;
  font-size: 110%;
  text-align: left;
  font-weight: bolder;
}

.button-permanecer {
  background: #00456e;
  color: #fff !important;
}

.button-permanecer2 {
  background: #40bccc;
  color: #fff !important;
}
.special-flex {
  display: flex;
  justify-content: flex-end;
}

.btn-width-maior {
  width: 90%;
}
@media only screen and (max-width: 992px) {
  .btn-mobile-special {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalEmitirEndossoAlteracao.vue